<template>
	<Icon v-if="icon" :name="icon" :size="sizePX" />
</template>

<script setup lang="ts">
import type { PatientMeta } from "@/types/patient"
import { computed } from "vue"
import Icon from "@/components/common/Icon.vue"
import { ICONS } from "@/const"

const { meta, size } = defineProps<{
	meta: PatientMeta
	size?: "small" | "medium" | "large" | "tiny" | number
}>()

const sizePX = computed(() =>
	size === "small" ? 12 : size === "large" ? 16 : size === "tiny" ? 10 : size === "medium" ? 14 : size
)

const icon = computed<string | null>(() => {
	switch (meta.status) {
		case "PREGNANCY":
			return ICONS.status.pregnancy
		case "FERTILITY":
			return ICONS.status.fertility
		case "MENOPAUSE":
			return ICONS.status.menopause
		case "VOLUNTARY_ABORTION":
		case "NATURAL_ABORTION":
		case "UNKNOWN_ABORTION":
			return ICONS.status.abortion
		case "POST_PARTUM":
			return ICONS.status.post_partum
		case "UNKNOWN":
			return ICONS.status.unknown
		default:
			return null
	}
})
</script>
